export class TestABUtils {
  public static getNowMilliseconds(): number {
      const newDate = new Date();
      newDate.setMinutes(newDate.getMinutes() - newDate.getTimezoneOffset());
      return newDate.getTime();
  }
}
